export const messages = {
  en: {
    adminOwner: {
      searchTitle: 'Search Conditions',
      ownerInfo: 'Owner Information',
      personRole: 'Person Role',
      selectPersonRole: 'Please select person role',
      personType: 'Person Type',
      selectPersonType: 'Please select person type',
      customerName: 'Customer Name',
      inputCustomerName: 'Please input customer name',
      roomNumber: 'Room Number',
      inputRoomNumber: 'Building-Unit-Room',
      contact: 'Contact',
      inputContact: 'Please input contact',
      idCard: 'ID Card',
      inputIdCard: 'Please input ID card',
      search: 'Search',
      reset: 'Reset',
      all: 'All',
      personal: 'Personal',
      company: 'Company',
      face: 'Face',
      communityName: 'Community Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      operation: 'Operation',
      detail: 'Detail',
      oweFee: 'Owe Fee',
      roomCount: 'Room Count',
      memberCount: 'Member Count',
      carCount: 'Car Count',
      backupPhone: 'Backup Phone',
      contactPhone: 'Contact Phone',
      fetchError: 'Failed to fetch owner data',
      address: 'Address',
    }
  },
  zh: {
    adminOwner: {
      searchTitle: '查询条件',
      ownerInfo: '业主信息',
      personRole: '人员角色',
      selectPersonRole: '请选择人员角色',
      personType: '人员类型',
      selectPersonType: '请选择人员类型',
      customerName: '客户名称',
      inputCustomerName: '请输入客户名称',
      roomNumber: '房屋编号',
      inputRoomNumber: '楼栋-单元-房屋',
      contact: '联系方式',
      inputContact: '请输入联系方式',
      idCard: '身份证号',
      inputIdCard: '请输入业主身份证号',
      search: '查询',
      reset: '重置',
      all: '全部',
      personal: '个人',
      company: '公司',
      face: '人脸',
      communityName: '小区名称',
      gender: '性别',
      male: '男',
      female: '女',
      operation: '操作',
      detail: '详情',
      oweFee: '欠费',
      roomCount: '房屋数',
      memberCount: '业主成员',
      carCount: '车辆数',
      backupPhone: '获客来源',
      contactPhone: '联系手机',
      fetchError: '获取业主数据失败',
      address: '地址',
    }
  }
}
